import mrFutureRequest from "../utils/mrFutureRequest";

export function getCurrentUserEditPermission() {
  return mrFutureRequest({
    url: "/company/host/screen/edit/permission",
    method: "get"
  });
}
